
    <h5>{{ plan.name }}</h5>
    <p>{{ plan.description }}</p>
    <span class="sub-price">${{ plan.amount }}<span>/{{ plan.type }}</span></span>
    <a href="javascript:void(0)" class="subscribe" (click)="subscribeNow()" *ngIf="!plan.is_subscribe">Subscribe Now</a>
    <a href="javascript:void(0)" class="no-cursor subscribed" *ngIf="plan.is_subscribe">Subscribed</a>
    <ul class="sub-list">
      <li>Stream on your favorite devices</li>
      <li>Watch on your laptop, TV, phone and tablet</li>
      <li>Hd video available</li>
      <li>Unlimited Kirupalu Nithi Speech videos</li>
    </ul>
